import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import { BannerText } from 'components/BannerText'
import { styled } from 'stitches.config'

export const Quote = () => {
  const { t } = useTranslation()

  const Header = styled(Text, {
    width: '100%',
    maxWidth: '380px',
    '@bp2' : {
        maxWidth: '1170px',
    }
  })

  return (
    <BannerText background='secondary-500'>
      <Header weight='regular' align='center' size={{'@initial': 'h3', '@bp2': 'h2'}} color='accent-white'>{t('why-we-feed-raw:quote.text')}</Header>
    </BannerText>
  )
}
